import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // when clicking outside the popup, hide it
    document.addEventListener("click", (e) => {
      if (!this.element.contains(e.target)) {
        this.close()
      }
    })
  }

  close() {
    this.element.classList.add("d-none")
  }
}
